export default {"src":"/_next/static/media/Anniversary.6e88b8de.svg","height":40,"width":40};